module.exports = __webpack_public_path__ + "static/media/Bryan Wade.11a9b9f5.png";